import React, { useRef } from 'react';
import './contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { FaWhatsapp } from 'react-icons/fa';

import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_7fxtau8', 'template_vwfetf4', form.current, 'izYC5cXhmXbTKze1r');

    e.target.reset();

    // .then(
    //   () => {
    //     console.log('SUCCESS!');
    //   },
    //   (error) => {
    //     console.log('FAILED...', error.text);
    //   },
    // );
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div data-aos="fade-right" data-aos-duration="2000" className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>nyamekye2131@gmail.com</h5>
            <a href="mailto:nyamekye2131@gmail.com" target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className="contact__option">
            <RiMessengerLine className="contact__option-icon" />
            <h4>Messenger</h4>
            <h5>Facebook-SMS</h5>
            <a href="https://m.me/evans.nyamekye" target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className="contact__option">
            <FaWhatsapp className="contact__option-icon" />
            <h4>WhatsApp</h4>
            <h5>+123456789</h5>
            <a href="https://api.whatsapp.com/send?phone+233530646942" target="_blank" rel="noreferrer">Send a message</a>
          </article>
        </div>
        <form data-aos="fade-left" data-aos-duration="2000" ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Full Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" rows="7" placeholder="Your Message" required />
          <button type="submit" className="btn btn-primary">Send Message</button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
